import 'angular:locale/data:pl';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "pl";
